(ns teamoesterreich.user-mode.modal.address-modal
  (:require [clojure.string :as str]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.location-on :refer [location-on]]
            [reagent-material-ui.styles :as mui-styles]
            [reagent.core :as r]
            [shadow.cljs.modern :refer (js-await)]
            [teamoesterreich.config :as config]
            [teamoesterreich.firebase.provider]
            [teamoesterreich.firebase.provider :as provider]
            ["react" :as react]
            ["maplibre-gl" :refer [LngLatBounds LngLat]]
            ["react-map-gl/maplibre" :refer [Map Marker Source Layer ScaleControl NavigationControl Popup FullscreenControl useControl Popup]]
            ["@maplibre/maplibre-gl-geocoder" :as MapLibreGeocoder]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.util.helper :as h]))

(def default-bounds
  (case config/CLIENT
    "toe" (LngLatBounds. (LngLat. 9.330640 46.345639) (LngLat. 17.292480 49.052270))
    "tb" (LngLatBounds. (LngLat. 8.919255 47.187879) (LngLat. 14.395939 50.616391))
    "tbonn" (LngLatBounds. (LngLat. 4.634788 47.274859) (LngLat. 14.611357 55.169539))
    ))

(def country-code
  (case config/CLIENT
    "toe" "AT"
    "tb" "DE"
    "tbonn" "DE"
    ))

(def map-style
  (case config/CLIENT
    "toe" "/map-style.json"
    "tb" "https://sgx.geodatenzentrum.de/gdz_basemapde_vektor/styles/bm_web_col.json"
    "tbonn" "https://sgx.geodatenzentrum.de/gdz_basemapde_vektor/styles/bm_web_col.json"))

; FIXME: fav-location vs. main_address location-ref

(defn update-address [lat lng zip city street streetNo]
  (let [fav-location-id (provider/get-fav-locationId)]
    (if @(r/cursor store/app-state [:locations fav-location-id])
      (js-await [_ (a/set-location fav-location-id {:coordinates (js/firebase.firestore.GeoPoint. lat lng)
                                                    :address     (str zip " " city ", " street " " streetNo)
                                                    :street      street
                                                    :streetNo    streetNo
                                                    :zip         zip
                                                    :city        city})]
        (a/set-user-details {:main_address          {:coordinates  (js/firebase.firestore.GeoPoint. lat lng)
                                                     :location-ref (a/get-location-ref fav-location-id)
                                                     :address      (str zip " " city ", " street " " streetNo)
                                                     :street       street
                                                     :streetNo     streetNo
                                                     :zip          zip
                                                     :city         city}
                             :user-addressLongitude lng
                             :user-addressLatitude  lat}))


      (a/create-location {:coordinates         (js/firebase.firestore.GeoPoint. lat lng)
                          :name                (str street " " streetNo)
                          :address             (str zip " " city ", " street " " streetNo)
                          :street              street
                          :streetNo            streetNo
                          :zip                 zip
                          :city                city
                          :preparation-enabled true}
                         (fn [locationId]
                           (a/set-user-details {:fav-location          (a/get-location-ref locationId)
                                                :main_address          {:coordinates  (js/firebase.firestore.GeoPoint. lat lng)
                                                                        :location-ref (a/get-location-ref locationId)
                                                                        :address      (str zip " " city ", " street " " streetNo)
                                                                        :street       street
                                                                        :streetNo     streetNo
                                                                        :zip          zip
                                                                        :city         city}
                                                :user-addressLongitude lng
                                                :user-addressLatitude  lat})
                           )))))

(defn format-address [address]
  (str (get address "road") " " (get address "house_number") ", " (get address "postcode") " " (get address "municipality" (get address "town" (get address "village" (get address "city"))))))

(defn nominatim-search [zip city street+no]
  (let [url (js/URL. "/search" config/NOMINATIM_URL)]
    (doto (.-searchParams url)
      (.set "format" "geojson")
      (.set "polygon_geojson" "1")
      (.set "addressdetails" "1")
      (.set "countrycodes" country-code)
      (.set "city" city)
      (.set "postalcode" zip)
      (.set "street" street+no))
    (js-await [response (js/fetch url)]
      (js-await [geojson (.json response)]
        (let [convert-features (fn [features]
                                 (clj->js {:features (mapv (fn [^js feature]
                                                             (let [bounds (LngLatBounds. (.-bbox feature))
                                                                   center (.getCenter bounds)
                                                                   name (format-address (js->clj (.. feature -properties -address)))]
                                                               #js{:type       "Feature"
                                                                   :geometry   #js{:type "Point" :coordinates center}
                                                                   :place_name name
                                                                   :properties (.-properties feature)
                                                                   :bounds     (LngLatBounds. (.-bbox feature))
                                                                   :text       name
                                                                   :place_type #js["place"]
                                                                   :center     center}))
                                                           features)}))]
          (if (empty? (js->clj (.-features geojson)))
            (let [url (js/URL. "/search" config/NOMINATIM_URL)]
              (doto (.-searchParams url)
                (.set "format" "geojson")
                (.set "polygon_geojson" "1")
                (.set "addressdetails" "1")
                (.set "countrycodes" country-code)
                (.set "q" (str zip " " city " " street+no)))
              (js-await [response (js/fetch url)]
                (js-await [geojson (.json response)]
                  (convert-features (.-features geojson)))))

            (convert-features (.-features geojson))))

        (catch e (js/console.error "Failed to forwardGeocode" e))))))

(defn nominatim-reverse [lat lon]
  (js-await [response (js/fetch (str config/NOMINATIM_URL "/reverse?lat=" lat "&lon=" lon "&format=geojson&polygon_geojson=1&addressdetails=1"))]
    (js-await [geojson (.json response)]
      (clj->js {:features (mapv (fn [^js feature]
                                  (let [center (.getCenter (LngLatBounds. (.-bbox feature)))
                                        name (format-address (js->clj (.. feature -properties -address)))]
                                    #js{:type       "Feature"
                                        :geometry   #js{:type "Point" :coordinates center}
                                        :place_name name
                                        :properties (.-properties feature)
                                        :text       name
                                        :place_type #js["place"]
                                        :center     center}))
                                (filter (fn [^js feature]
                                          (= (str/lower-case country-code) (str/lower-case (.. feature -properties -address -country_code))))
                                        (.-features geojson)))})
      (catch e (js/console.error "Failed to forwardGeocode" e)))))

(defn check-location [zip city street+no lngLat]
  (js-await [results (nominatim-search zip city street+no)]
    (let [features (js->clj (.-features results))]
      (if (empty? features)
        :not-found

        (if (not-any? #(.contains (get % "bounds") lngLat) features)
          (get (first features) "center")
          :matching)))))

(defn map-view [{:keys [^js map-ref mismatch-position position set-position set-address]}]
  (let [[click-location set-click-location] (react/useState)]
    [:> Map {:initialViewState (if (and position (.contains default-bounds (LngLat. (first position) (second position))))
                                 {:latitude  (second position)
                                  :longitude (first position)
                                  :zoom      18}
                                 {:bounds default-bounds})
             :mapStyle         map-style
             :dragRotate       false
             :dragPitch        false
             :touchPitch       false
             :onClick          (fn [event]
                                 (when (.contains default-bounds (.-lngLat event))
                                   (let [lat (.-lat (.-lngLat event))
                                         lng (.-lng (.-lngLat event))]
                                     (.easeTo ^js (.-current map-ref) #js{:center   #js[lng lat]
                                                                          :zoom     (max 18 (.getZoom (.-current map-ref)))
                                                                          :duration 150})
                                     (js-await [results (nominatim-reverse lat lng)]
                                       (let [result (first (js->clj (.-features results)))
                                             address (get-in result ["properties" "address"])]
                                         (set-click-location {:position [(.-lng (get result "center")) (.-lat (get result "center"))]
                                                              :text     (get result "text")
                                                              :streetNo (get address "house_number")
                                                              :street   (get address "road")
                                                              :city     (get address "municipality" (get address "town" (get address "village" (get address "city"))))
                                                              :zip      (get address "postcode")})))
                                     )))
             :ref              map-ref}

     (when position
       [:> Marker {:longitude (first position)
                   :latitude  (second position)
                   :anchor    "center"}
        [location-on {:color "primary" :fontSize "large"}]])

     (when mismatch-position
       [:> Marker {:longitude (first mismatch-position)
                   :latitude  (second mismatch-position)
                   :anchor    "center"}
        [location-on {:color "secondary" :fontSize "large"}]])

     (when click-location
       [:> Popup {:longitude (first (:position click-location))
                  :latitude  (second (:position click-location))
                  :onClose   (fn [] (set-click-location nil))
                  :anchor    "bottom"}
        [mui/box {:style {:display "flex" :flex-direction "column" :gap "8px"}}
         [mui/typography (:text click-location)]
         [mui/button {:fullWidth true
                      :color     "primary"
                      :variant   "outlined"
                      :size      "small"
                      :onClick   (fn []
                                   (set-address click-location)
                                   (set-click-location nil))}
          "Adresse verwenden"]
         [mui/button {:fullWidth true
                      :color     "secondary"
                      :size      "small"
                      :onClick   (fn []
                                   (set-position (:position click-location))
                                   (set-click-location nil))}
          "Nur Position korrigieren"]]
        ])

     [:> ScaleControl]
     [:> NavigationControl {:showCompass false}]]))

(defn modal-inner [!main-address !show-modal]
  (let [map-ref (react/useRef nil)
        u-coordinates (get-in @!main-address [:coordinates])
        u-street (get-in @!main-address [:street])
        u-streetNo (get-in @!main-address [:streetNo])
        u-zip (get-in @!main-address [:zip])
        u-city (get-in @!main-address [:city])
        [position set-position] (react/useState (when u-coordinates [(.-longitude ^js u-coordinates) (.-latitude ^js u-coordinates)]))
        [street set-street] (react/useState (str u-street))
        [streetNo set-streetNo] (react/useState (str u-streetNo))
        [zip set-zip] (react/useState (str u-zip))
        [city set-city] (react/useState (str u-city))
        [check-location? set-check-location?] (react/useState false)
        [location-not-found? set-location-not-found?] (react/useState false)
        [resolved-mismatch-location set-resolved-mismatch-location] (react/useState nil)
        set-zoom-position (fn [[lng lat]]
                            (when (and lat lng)
                              (set-position #js[lng lat])
                              (.easeTo ^js (.-current map-ref) #js{:center   #js[lng lat]
                                                                   :zoom     (max 16 (.getZoom (.-current map-ref)))
                                                                   :duration 150})))
        theme (mui-styles/use-theme)
        fullScreen (mui/use-media-query ((get-in theme [:breakpoints :down]) "md"))]
    [mui/dialog
     {
      :fullScreen fullScreen
      :maxWidth   "lg"
      :open       @!show-modal
      :onClose    (fn [])                                   ; ignore non-button close
      }
     [mui/dialog-title "Adresse bearbeiten"]
     [mui/dialog-content
      [mui/box
       {:sx {:display            "grid"
             :grid-template-rows "auto auto 1fr auto"
             :height             "100%"
             :min-height         "50vh"
             :padding-bottom     "1rem"}
        }

       [mui/typography {:variant "subtitle1" :gutterBottom true} "Bitte gib deine Adresse ein und prüfe auf der Karte, ob der Standort korrekt ist."]


       [mui/box {:sx {:display               "grid"
                      :grid-template-columns {:xs "1fr" :sm "1fr 2fr 2fr 1fr"}
                      :gap                   "1rem"}}

        [mui/text-field {:label     "PLZ ⁽*⁾"
                         :value     (str zip)
                         :onChange  (fn [e]
                                      (set-zip (h/event-value e))
                                      (set-check-location? true)
                                      (set-resolved-mismatch-location nil))
                         :error     (empty? zip)
                         :fullWidth true
                         }]

        [mui/text-field {:label     "Ort ⁽*⁾"
                         :value     (str city)
                         :onChange  (fn [e]
                                      (set-city (h/event-value e))
                                      (set-check-location? true)
                                      (set-resolved-mismatch-location nil))
                         :error     (empty? city)
                         :fullWidth true
                         }]


        [mui/text-field {:label     "Straße ⁽*⁾"
                         :value     (str street)
                         :onChange  (fn [e]
                                      (set-street (h/event-value e))
                                      (set-check-location? true)
                                      (set-resolved-mismatch-location nil))
                         :error     (empty? street)
                         :fullWidth true
                         }]

        [mui/text-field {:label     "Hausnummer"
                         :value     (str streetNo)
                         :onChange  (fn [e]
                                      (set-streetNo (h/event-value e))
                                      (set-check-location? true)
                                      (set-resolved-mismatch-location nil))
                         :fullWidth true
                         }]
        ]

       [mui/box {:sx {:margin-bottom "1rem" :margin-top "1rem" :min-height "16rem"}}
        [:f> map-view {:position          position
                       :mismatch-position resolved-mismatch-location
                       :map-ref           map-ref
                       :set-position      (fn [pos]
                                            (set-check-location? (not location-not-found?))
                                            (set-resolved-mismatch-location nil)
                                            (set-zoom-position pos))
                       :set-address       (fn [address]
                                            (set-check-location? true)
                                            (set-resolved-mismatch-location nil)
                                            (set-zoom-position (:position address))
                                            (set-zip (get address :zip zip))
                                            (set-city (get address :city city))
                                            (set-street (get address :street street))
                                            (set-streetNo (get address :streetNo streetNo)))}]]

       (when resolved-mismatch-location
         [mui/typography {:variant "body2" :color "error"}
          "ACHTUNG: Adresse und Kartenstandort stimmen laut unseren Daten nicht überein"])

       (when location-not-found?
         [mui/typography {:variant "body2" :color "error"}
          "ACHTUNG: Adresse nicht gefunden, bitte auf der Karte wählen und Position korrigieren, dann nochmal speichern."])
       ]
      ]
     [mui/dialog-actions
      [mui/button
       {:variant "outlined"
        :color   "secondary"
        :onClick (fn []
                   (reset! !show-modal false))}
       "Abbrechen"]
      [mui/button
       {:color    "primary"
        :variant  "contained"
        :disabled (or (empty? zip) (empty? city) (empty? street) (and (some? position) (not (.contains default-bounds (LngLat. (first position) (second position))))))
        :onClick  (fn []
                    (if (nil? position)
                      (js-await [results (nominatim-search zip city (str street " " (first (re-find #"^[0-9a-zA-Z]+" streetNo))))]
                        (if (empty? (js->clj (.-features results)))
                          (set-location-not-found? true)

                          (let [result (first (js->clj (.-features results)))
                                address (get-in result ["properties" "address"])]
                            (set-location-not-found? false)
                            (set-check-location? false)
                            (set-zoom-position [(.-lng (get result "center")) (.-lat (get result "center"))])
                            (set-zip (get address "postcode"))
                            (set-city (get address "municipality" (get address "town" (get address "village" (get address "city")))))
                            (set-street (get address "road"))
                            (set-streetNo (get address "house_number" streetNo)))))

                      (-> (if check-location?
                            (check-location zip city (str street " " (first (re-find #"^[0-9a-zA-Z]+" streetNo))) (LngLat. (first position) (second position)))
                            (js/Promise. (fn [resolve] (resolve :matching))))
                          (.then (fn [mismatch-location]
                                   (cond
                                     (= mismatch-location :matching)
                                     (do
                                       (set-resolved-mismatch-location nil)
                                       (set-location-not-found? false)
                                       (-> (update-address (second position) (first position) zip city street streetNo)
                                           (.then (fn [_] (reset! !show-modal false)))))

                                     (= mismatch-location :not-found)
                                     (do
                                       (set-resolved-mismatch-location nil)
                                       (set-location-not-found? true)
                                       (set-check-location? false)
                                       (set-position nil))

                                     :else
                                     (do
                                       (set-resolved-mismatch-location [(.-lng mismatch-location) (.-lat mismatch-location)])
                                       (set-check-location? false)
                                       (set-location-not-found? false)
                                       (.flyTo ^js (.-current map-ref)
                                               (.cameraForBounds ^js (.-current map-ref)
                                                                 (-> (LngLatBounds.)
                                                                     (.extend mismatch-location)
                                                                     (.extend (LngLat. (first position) (second position))))
                                                                 #js{:padding 96}))))))

                          ))
                    )}
       (cond
         (nil? position)
         "Adresse suchen"

         (some? resolved-mismatch-location)
         "Adresse trotzdem speichern"

         :else
         "Adresse speichern")
       ]

      ]
     ]
    ))

(defn address-modal [!show-modal]
  (let [!main-address (r/cursor store/app-state [:actual-user :main_address])]
    (fn [!show-modal]
      [:f> modal-inner !main-address !show-modal]
      )
    ))